import React from 'react'
import '../profileClient/ProfileClient.css'
import ClientProfileAuthorTop from '../../components/clientProfileAuthor/ClientProfileAuthorTop'
import ClientReview from '../../components/clientReview/ClientReview'
import ClientProfileAuthorBottom from '../../components/clientProfileAuthor/ClientProfileAuthorBottom'

const ProfileClient = () => {
  return (
    <div className='dashboard-content-box dashboard-profile-Client'>
        <div className='top-profile-box'>
            <ClientProfileAuthorTop />
        </div>
        <div className='client-reviews-sec'>
            <ClientReview />
        </div>
        <div className='client-bottom-follow-sec'>
            <ClientProfileAuthorBottom />
        </div>
    </div>
  )
}

export default ProfileClient
